import _taggedTemplateLiteral from "/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

import React from 'react';
import styled from 'styled-components';
import { Icon } from '../icon/Icon';
import { Loader } from '../loader';
import { makeButtonIcon, makeDefaultButton, makeDisabledButton } from './mixins';
export var ButtonIcon = styled(Icon)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  return makeButtonIcon(props);
});
export var DefaultButton = styled.button(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  return makeDefaultButton(props);
});
export var DisabledButtonComponent = styled(DefaultButton)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  return makeDisabledButton(props);
});

var LoadingButton = function LoadingButton(props) {
  var children = props.children,
      buttonoptions = props.buttonoptions;
  return React.createElement(DisabledButtonComponent, Object.assign({}, Object.assign(Object.assign({}, props), {
    disabled: true
  }), buttonoptions, {
    content: children
  }), React.createElement(Loader, null));
};

var DisabledButton = function DisabledButton(props) {
  var icon = props.icon,
      children = props.children,
      buttonoptions = props.buttonoptions;
  return React.createElement(DisabledButtonComponent, Object.assign({}, props, buttonoptions, {
    content: children
  }), icon && icon.name && React.createElement(ButtonIcon, Object.assign({}, icon, {
    buttonoptions: buttonoptions,
    content: children
  })), children);
};

var ButtonComponent = function ButtonComponent(props) {
  var id = props.id,
      icon = props.icon,
      children = props.children,
      buttonoptions = props.buttonoptions;
  return React.createElement(DefaultButton, Object.assign({
    id: id
  }, props, buttonoptions, {
    content: children
  }), icon && icon.name && React.createElement(ButtonIcon, Object.assign({}, icon, {
    buttonoptions: buttonoptions,
    content: children
  })), children);
};

export var Button = function Button(props) {
  var _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$isLoading = props.isLoading,
      isLoading = _props$isLoading === void 0 ? false : _props$isLoading;

  if (isLoading) {
    return LoadingButton(props);
  }

  if (disabled) {
    return DisabledButton(props);
  }

  return ButtonComponent(props);
};